import axios, { AxiosError, CancelTokenSource } from 'axios';
import { ApiUrls } from '../constants/apiUrls'
import { ApiResponseHelper } from '../infrastructure/utils/ApiResponseHelper'
import { IApiResponse } from '../models/ApiResponseModels'
import { AttachPersonalAccountCommand, AvailableEquipment, PersonalAccountInformation } from '../models/AccountModels'
import {  CreateMainContactCommand } from '../models/ClientManagerModels';


export class AccountManagerRequests {
    private cancelTokenSource?: CancelTokenSource


    public Init(): void {
        this.cancelTokenSource = axios.CancelToken.source();
    }

    public Abort(): void {
        this.cancelTokenSource?.cancel();

    }


    public async GetCountPersonalAccount(): Promise<IApiResponse<number | null>> {


        return await axios.get<IApiResponse<number | null>>(`${ApiUrls.GetCountPersonalAccount}`,
            { cancelToken: this.cancelTokenSource?.token })
            .then(response => {
                return response.data;
            })
            .catch((error: AxiosError) => {
                if (axios.isCancel(error)) {
                    return { result: true, data: null, error: null, messageId: null }
                }
                return { result: false, data: null, error: ApiResponseHelper.GeneratorAxiosError(error), messageId: null }
            })
    }

    public async GetAttachPersonalAccount(): Promise<IApiResponse<string[]>> {


        return await axios.get<IApiResponse<string[]>>(`${ApiUrls.GetAttachPersonalAccount}`,
            { cancelToken: this.cancelTokenSource?.token })
            .then(response => {
                return response.data;
            })
            .catch((error: AxiosError) => {
                if (axios.isCancel(error)) {
                    return { result: true, data: [], error: null, messageId: null }
                }
                return { result: false, data: [], error: ApiResponseHelper.GeneratorAxiosError(error), messageId: null }
            })
    }

    public async AttachPersonalAccount(command: AttachPersonalAccountCommand): Promise<IApiResponse<string | null>> {


        return await axios.post<IApiResponse<string | null>>(`${ApiUrls.AttachPersonalAccount}`,
            command,
            { cancelToken: this.cancelTokenSource?.token })
            .then(response => {
                return response.data;
            })
            .catch((error: AxiosError) => {
                if (axios.isCancel(error)) {
                    return { result: true, data: null, error: null, messageId: null }
                }
                return { result: false, data: null, error: ApiResponseHelper.GeneratorAxiosError(error), messageId: null }
            })
    }


    public async UnAttachPersonalAccount(personalAccountId: string): Promise<IApiResponse<{} | null>> {


        return await axios.post<IApiResponse<{} | null>>(`${ApiUrls.UnAttachPersonalAccount}`,
            {
                personalAccountId: personalAccountId
            },
            { cancelToken: this.cancelTokenSource?.token })
            .then(response => {
                return response.data;
            })
            .catch((error: AxiosError) => {
                if (axios.isCancel(error)) {
                    return { result: true, data: null, error: null, messageId: null }
                }
                return { result: false, data: null, error: ApiResponseHelper.GeneratorAxiosError(error), messageId: null }
            })
    }


    public async GetPersonalAccountInformation(personalAccountId: string): Promise<IApiResponse<PersonalAccountInformation | null>> {


        return await axios.get<IApiResponse<PersonalAccountInformation | null>>(`${ApiUrls.GetPersonalAccountInformation}?personalAccountId=${personalAccountId}`,
            { cancelToken: this.cancelTokenSource?.token })
            .then(response => {
                return response.data;
            })
            .catch((error: AxiosError) => {
                if (axios.isCancel(error)) {
                    return { result: true, data: null, error: null, messageId: null }
                }
                return { result: false, data: null, error: ApiResponseHelper.GeneratorAxiosError(error), messageId: null }
            })
    }

    public async GetAvailableEquipments(personalAccountId: string): Promise<{ personalAccountId: string, response: IApiResponse<AvailableEquipment[]> }> {

        return await axios.get<IApiResponse<AvailableEquipment[]>>(`${ApiUrls.GetAvailableEquipments}?personalAccountId=${personalAccountId}&Type=1`,
            { cancelToken: this.cancelTokenSource?.token })
            .then(response => ({
                personalAccountId: personalAccountId,
                response: response.data
            }))
            .catch((error: AxiosError) => ({
                personalAccountId: personalAccountId,
                response: ApiResponseHelper.GetDefaultArrayResponse<AvailableEquipment>()
            }))
    }




    public async IsExistsMainContact(): Promise<IApiResponse<boolean>> {


        return await axios.get<IApiResponse<boolean>>(`${ApiUrls.IsExistsMainContact}`,
            { cancelToken: this.cancelTokenSource?.token })
            .then(response => {
                return response.data;
            })
            .catch((error: AxiosError) => {
                if (axios.isCancel(error)) {
                    return { result: true, data: false, error: null, messageId: null }
                }
                return { result: false, data: false, error: ApiResponseHelper.GeneratorAxiosError(error), messageId: null }
            })
    }

    public async CreateMainContact(command:  CreateMainContactCommand): Promise<IApiResponse<{} | null>> {
        return await axios.post<IApiResponse<{} | null>>(`${ApiUrls.CreateMainContact}`,
            command,
            { cancelToken: this.cancelTokenSource?.token })
            .then(response => {
                return response.data;
            })
            .catch((error: AxiosError) => {
                if (axios.isCancel(error)) {
                    return { result: true, data: null, error: null, messageId: null }
                }
                return { result: false, data: null, error: ApiResponseHelper.GeneratorAxiosError(error), messageId: null }
            })
    }




}
